export const UPDATE_CRITERIA_TAB = 'UPDATE_CRITERIA_TAB';
export const UPDATE_AUDIT_TAB = 'UPDATE_AUDIT_TAB'
export const UPDATE_STUDENT_PROCESS_TAB = 'UPDATE_STUDENT_PROCESS_TAB'
